import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../store";

export const useActions = () => {
  const dispatch = useDispatch();

  // return bindActionCreators(actions, dispatch);
  return useMemo(() => {
    return bindActionCreators(actions, dispatch);
  }, [dispatch]);
};
